import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import Login from "../Login/Login.js";

export const SigninSection = ({
  callback = null,
  inviteDomainName,
  addSubUserToOrganization,
  completeAddSubUser,
  AuthenticationOptions,
  enforceStrongPass,
}) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const handleClick = () => {
    setModal({
      modal: Login,
      modalSize: "full-modal",
      props: {
        enforceStrongPass,
        callback,
        inviteDomainName,
        addSubUserToOrganization,
        completeAddSubUser,
        AuthenticationOptions,
      },
    });
  };

  return (
    <div className="signin-section">
      <div className="image-container">
        <Image
          className="sign-in-image"
          name="registration"
          ext="png"
          alt={getTextByKey("create-new-account-title")}
        />
      </div>
      <div className="title">
        {inviteDomainName
          ? getTextByKey("join-to-domain").replace(
              "#DomainName#",
              inviteDomainName
            )
          : getTextByKey("create-new-account-title")}
      </div>
      {!inviteDomainName ? (
        <div className="text-content">
          {getTextByKey("create-new-account-subtitle")}
        </div>
      ) : null}
      <div className="signin-call-to-action">
        <div className="signin-call-to-action-text">
          {getTextByKey("signin-already-a-member-text")}
        </div>
        <div className="signin-call-to-action-link" onClick={handleClick}>
          {getTextByKey("signin-already-a-member-link")}
        </div>
      </div>
    </div>
  );
};
